<template>
  <van-popup v-model="show" position="bottom">
    <div class="popup">
      <div class="popup-title">
        <span class="popup-title-cancle" @click="close">取消</span>
        <span class="popup-title-confirm" @click="confirmPicker">确定</span>
      </div>
      <div class="popup-line"></div>
      <div class="popup-list">
        <div v-for="(item, index) in list" :key="index"
          :class="activeIndex === index ? 'popup-list-item-active' : 'popup-list-item'" @click="activeIndex = index">
          <span :class="activeIndex === index ? 'popup-list-item-active-span' : 'popup-list-item-span'">{{ item }}</span>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'

Vue.use(Popup)

export default {
  data() {
    return {
      show: false,
      activeIndex: -1,
      list: ["京", "津", "渝", "沪", "冀", "晋", "辽", "吉", "黑", "苏", "浙", "皖", "闽", "赣", "鲁", "豫", "鄂", "湘", "粤", "琼", "川",
        "贵", "云", "陕", "甘", "青", "蒙", "桂", "宁", "新", "藏", "使", "领", "警", "学", "澳", "港"
      ]
    };
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    confirmPicker() {
      this.close()
      this.$emit('confirm', this.list[this.activeIndex])
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  width: 100vw;
  background-color: $color-white;
  @include relative;

  &-title {
    height: 65px;
    padding: 0 24px;
    @extend .flex-row;
    justify-content: space-between;
    align-items: center;

    &-cancle {
      @include text(22px, 400, $color-grey);
    }

    &-confirm {
      @include text(22px, 400, rgba(239, 81, 43, 1));
    }
  }

  &-line {
    height: 2px;
    background-color: rgba(238, 238, 238, 1);
  }

  &-list {
    margin-top: 7px;
    margin-bottom: 7px;
    @extend .flex-row;
    justify-content: center;
    flex-wrap: wrap;

    &-item {
      width: 60px;
      height: 60px;
      margin: 4px;
      border-radius: 10px;
      @extend .flex-row-center;
      background-color: $color-bg;

      &-active {
        width: 60px;
        height: 60px;
        margin: 4px;
        border-radius: 10px;
        @extend .flex-row-center;
        background-color: rgba(239, 81, 43, 1);

        &-span {
          @include text(20px, 400, $color-white);
        }
      }

      &-span {
        @include text(20px, 400, $color-grey);
      }
    }
  }
}
</style>